import { defineComponent as _defineComponent } from 'vue';
import useProductContent from '~/composables/useProductContent/useProductContent';
import RenderContent from '~/components/cms/page/RenderContent.vue';
import AzAccordion from '~/components/_next/molecules/AzAccordion.vue';
import AzAccordionItem from '~/components/_next/molecules/AzAccordionItem.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockExpandableTabStandard',
  props: {
    title: null,
    catchphrase: null,
    image: null,
    isLast: {
      type: Boolean
    },
    isInsideBlockList: {
      type: Boolean
    },
    contents: null,
    classes: null,
    index: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var components = computed(function () {
      return mapComponentName(props.contents, {
        isContentExpanded: false,
        centerBullets: false,
        backgroundWhite: props.classes.container === 'background-white',
        isInExpandableTab: true
      });
    });
    return {
      __sfc: true,
      props: props,
      mapComponentName: mapComponentName,
      components: components,
      RenderContent: RenderContent,
      AzAccordion: AzAccordion,
      AzAccordionItem: AzAccordionItem,
      AzImg: AzImg
    };
  }
});